import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fcsro-error403',
  templateUrl: './error403.component.html',
  styleUrls: ['./error403.component.css']
})
export class Error403Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
